import { render } from "./B2bTableOrdersReceived.vue?vue&type=template&id=47625645&scoped=true&lang=pug"
import script from "./B2bTableOrdersReceived.vue?vue&type=script&lang=js"
export * from "./B2bTableOrdersReceived.vue?vue&type=script&lang=js"

import "./B2bTableOrdersReceived.vue?vue&type=style&index=0&id=47625645&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47625645"]])

export default __exports__